import {
  compareWithLogicalOrder,
  isMonthOrWeekField,
} from '../../ChartOptions/Sort/dataOrdeingUtils';
import {
  getFieldNamesByAxis,
  extractFieldsData,
  multiFieldSort,
  getFieldUidsByAxis,
} from '../../ChartOptions/Sort/reusableFunctions';

/**
 * This function is getting called in makeServiceCall.ts and useChartData.tsx
 * It sort chart data based on field name.
 */
export const sortChartData = (
  chartData: any[],
  chartProp: any,
  chartControls: any,
  _propKey: string,
  tooltipFormats?: any,
  _sortOrder?: string,
): any[] => {
  let result: any[] = [];
  let chartType = chartProp.chartType;
  let axesValues1 = JSON.parse(JSON.stringify(chartProp.chartAxes));

  if (tooltipFormats) {
    //--Replace chart axis measure fields and add extra measure fields to get sorted data for extra measure. --//
    const tempAxes = JSON.parse(JSON.stringify(axesValues1));
    const extraMeasureAxis = JSON.parse(JSON.stringify(tooltipFormats?.extraMeasureField[0]));
    if (chartType === 'scatterPlot') {
      //--either add in x axis or in y---//
      const XAxisIndex = tempAxes.findIndex((axis: any) => axis.name === 'X Axis');
      extraMeasureAxis.fields.forEach((field: any) => tempAxes[XAxisIndex].fields.push(field));
    } else {
      const measureAxisIndex = tempAxes.findIndex((axis: any) => axis.name === 'Measure');
      extraMeasureAxis.fields.forEach((field: any) =>
        tempAxes[measureAxisIndex].fields.push(field),
      );
    }
    axesValues1 = JSON.parse(JSON.stringify(tempAxes));
  }

  if (chartData && chartData.length > 0) {
    let _zones: any = axesValues1.filter((zones: any) => zones.name !== 'Filter');

    let _chartFieldTempObject: any = {};

    /*	Find and return field's new name	*/
    const findFieldIndexName = (name: string, i: number = 2): string => {
      if (_chartFieldTempObject[`${name}_${i}`] !== undefined) {
        i++;
        return findFieldIndexName(name, i);
      } else {
        return `${name}_${i}`;
      }
    };

    _zones.forEach((zoneItem: any) => {
      zoneItem.fields.forEach((field: any) => {
        if (Object.keys(chartData[0]).includes(field.fieldname)) {
          let _nameWithAgg: string = '';

          _nameWithAgg = field.displayname;

          if (_chartFieldTempObject[field.fieldname] !== undefined) {
            let _name = findFieldIndexName(field.fieldname);

            field['NameWithIndex'] = _name;
            _chartFieldTempObject[_name] = '';
          } else {
            field['NameWithIndex'] = field.fieldname;
            _chartFieldTempObject[field.fieldname] = '';
          }
          field['NameWithAgg'] = _nameWithAgg;
        }
      });
    });

    chartData.forEach((data: any) => {
      let _chartDataObj: any = {};

      _zones.forEach((zoneItem: any) => {
        zoneItem.fields.forEach((field: any) => {
          _chartDataObj[field.NameWithAgg] = data[field.NameWithIndex];
        });
      });
      result.push(_chartDataObj);
    });
  }

  // Get sort configurations from chartControls
  const sortConfigurations = chartControls.properties[_propKey]?.sortConfigurations || [];
  const validConfigs = sortConfigurations.filter((config: any) => config.sortOrder);
  const chartAxes = chartProp.chartAxes;
  const rowFieldNames = getFieldNamesByAxis(chartAxes, 'Row');
  const columnFieldNames = getFieldNamesByAxis(chartAxes, 'Column');
  const measureFieldUids = getFieldUidsByAxis(chartAxes, 'Measure');
  const dimensionFieldNames = getFieldNamesByAxis(chartAxes, 'Dimension');
  const splitByFieldNames = getFieldNamesByAxis(chartAxes, 'Split By');
  const rowFieldsData = extractFieldsData(result, rowFieldNames);
  const columnFieldsData = extractFieldsData(result, columnFieldNames);

  const chartPropertiesWrapper = {
    properties: {
      [_propKey]: chartProp,
    },
  };

  // Apply multi-field sorting if configurations exist
  result = multiFieldSort({
    data: result,
    sortConfigurations,
    chartProperties: chartPropertiesWrapper,
    propKey: _propKey,
    rowFieldsData,
    columnFieldsData,
    rowFieldNames,
    columnFieldNames,
    dimensionFieldNames,
    splitByFieldNames,
    measureFieldUids,
  });

  return result;
};
